import { AppProvider } from './context/AppContext';
import { LeadForm } from './components/LeadForm';
import { Header } from './components/sections/Header';
import { Hero } from './components/sections/Hero';
import { TrustStrip } from './components/sections/TrustStrip';
import { HowItWorks } from './components/sections/HowItWorks';
import { WhyRosa } from './components/sections/WhyRosa';
import { InteractiveBathroom } from './components/sections/InteractiveBathroom';
import { StatsBand } from './components/sections/StatsBand';
import { Families } from './components/sections/Families';
import { MedicareWidget } from './components/sections/MedicareWidget';
import { CoverageBand } from './components/sections/CoverageBand';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';

export default function App() {
  return (
    <AppProvider>
      <div className="min-h-screen overflow-x-clip bg-blush">
        <Header />
        <main className="overflow-x-clip">
          <Hero />
          <TrustStrip />
          <HowItWorks />
          <WhyRosa />
          <InteractiveBathroom />
          <StatsBand />
          <Families />
          <MedicareWidget />
          <CoverageBand />
          <Faq />
          <FinalCta />
        </main>
        <Footer />
        <LeadForm />
      </div>
    </AppProvider>
  );
}
